//store
import * as DebtsStore from "../../../../redux/middleware/CashFlow-Debts.Middleware";
import * as PersonsStore from "../../../../redux/middleware/Persons.Middleware";

// models
import { Person } from "../../../../models/Entities/Person/Person";
import { Debt } from "../../../../models/Entities/CashFlow/Debt/Debt";
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { ErrorType } from "../../../../models/HttpError";
import { AppState } from "../../../../redux/reducers";

import * as jwt_decode from "jwt-decode";

// form types
export enum FormType {
  Debtor = 1,
  Creditor = 2
}

//#region Props

interface IProps {
    /** Creditor: el centro cobra (deuda a cobrar). Debtor: el centro paga. */
    FormType: FormType;
    ReferalId: string | undefined;
    FixedAssociatedEntityIdentifier: string | undefined;
    DebtId?: number;
    /** Contraparte para arrancar ya elegida (por ejemplo, la filtrada en la pantalla). */
    PrefillCounterpartId?: string;
    isOpen: boolean;
    onClose: () => void;
  }

  interface ConnectedProps {
    isLoading: boolean;
    isSaving: boolean;
    isSaved: boolean | undefined;
    failOnSaving: boolean;
    error: ErrorType | undefined;

    CurrentDebt: Debt | undefined;
    OwnerId: string;
    /** Contraparte fija (ficha de sponsor o proveedor), si la hay. */
    FixedCounterpart: Person | undefined;
    Persons: Person[];
    /** Para sugerir moneda: todo lo que hay en la caja. */
    AllDebts: Debt[];
    AllPayments: Payment[];
    NameOf: (identifier: string | undefined) => string;
  }

  interface DispatchProps {
    GetDebtById: typeof DebtsStore.actionCreators.GetDebtById;
    CreateDebt: typeof DebtsStore.actionCreators.CreateDebt;
    UpdateDebt: typeof DebtsStore.actionCreators.UpdateDebt;
    GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
  }

  export type Props = IProps & ConnectedProps & DispatchProps;

export const GetPersonByIdentifier = (persons: Person[], tenantId: string, identifier: string): Person | undefined => {
    if (!identifier) return undefined;
    if (identifier === tenantId) return { personIdentifier: tenantId, businessName: 'Centro Médico' } as Person;
    return persons.find((person: Person) => person.personIdentifier === identifier);
};

  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const currentDebt = ownProps.DebtId
        ? (state?.CashFlowDebts?.DebtsAsDebtor?.find((debt: Debt) => debt.id === ownProps.DebtId)
            ?? state?.CashFlowDebts?.DebtsAsCreditor?.find((debt: Debt) => debt.id === ownProps.DebtId))
        : undefined;

    const currentOwner: string = (jwt_decode.jwtDecode(state?.oidc?.user?.access_token!) as any)?.tenantId;
    const persons = state.Persons?.list || [];

    return ({
        isLoading: state.CashFlowDebts?.isLoadingOne || false,
        isSaving: currentDebt ? !!(currentDebt.isUpdating || currentDebt.isSaving) : state.CashFlowDebts?.isAddingNewOne || false,
        isSaved: currentDebt ? (currentDebt.isUpdatedSuccessfully || currentDebt.isSavedSuccessfully) : state.CashFlowDebts?.successAddingNewOne || undefined,
        failOnSaving: currentDebt ? !!(currentDebt.failOnUpdating || currentDebt.failOnSaving) : state.CashFlowDebts?.failOnAddingNewOne || false,
        error: state.CashFlowDebts?.error || currentDebt?.error || undefined,

        CurrentDebt: currentDebt,
        OwnerId: currentOwner,
        FixedCounterpart: GetPersonByIdentifier(persons, currentOwner, ownProps.FixedAssociatedEntityIdentifier || ''),
        Persons: persons,
        AllDebts: [...(state.CashFlowDebts?.DebtsAsCreditor || []), ...(state.CashFlowDebts?.DebtsAsDebtor || [])],
        AllPayments: [...(state.CashFlowPayments?.paymentsReceived || []), ...(state.CashFlowPayments?.paymentsDone || [])],
        NameOf: (identifier: string | undefined) => GetPersonByIdentifier(persons, currentOwner, identifier || '')?.businessName || identifier || '—'
    })
  };

  export const mapDispatchToProps = {
    GetDebtById: DebtsStore.actionCreators.GetDebtById,
    CreateDebt: DebtsStore.actionCreators.CreateDebt,
    UpdateDebt: DebtsStore.actionCreators.UpdateDebt,
    GetAllPersons: PersonsStore.actionCreators.GetAllPersons
  };
